(function () {
  'use strict';

  var store = {
    get: function (key, fallback) {
      try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
    },
    set: function (key, value) {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
    }
  };
  window.tayroStore = store;

  /* Mobile menu */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Member flag on body (unblurs sneak peeks) */
  if (window.tayro && window.tayro.isMember) document.body.classList.add('is-member');

  /* Shop category tabs */
  document.querySelectorAll('[data-filter-tabs]').forEach(function (tabs) {
    var grid = document.querySelector(tabs.getAttribute('data-filter-tabs'));
    if (!grid) return;
    tabs.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-filter]');
      if (!btn) return;
      var value = btn.getAttribute('data-filter');
      tabs.querySelectorAll('button').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      grid.querySelectorAll('[data-type]').forEach(function (card) {
        card.classList.toggle('is-hidden', value !== 'all' && card.getAttribute('data-type') !== value);
      });
    });
  });

  /* Daily Word: show today's verse, let people tap other days */
  document.querySelectorAll('[data-daily-word]').forEach(function (root) {
    var verses = root.querySelectorAll('[data-verse-day]');
    var days = root.querySelectorAll('[data-week-day]');
    function show(dayIndex) {
      var found = false;
      verses.forEach(function (v) {
        var match = Number(v.getAttribute('data-verse-day')) === dayIndex;
        v.hidden = !match;
        if (match) found = true;
      });
      if (!found && verses.length) verses[0].hidden = false;
      days.forEach(function (d) {
        d.classList.toggle('is-selected', Number(d.getAttribute('data-week-day')) === dayIndex);
      });
    }
    var today = new Date().getDay();
    days.forEach(function (d) {
      if (Number(d.getAttribute('data-week-day')) === today) d.classList.add('is-today');
      d.addEventListener('click', function () {
        show(Number(d.getAttribute('data-week-day')));
        var card = root.querySelector('[data-verse-anchor]');
        if (card) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var dateEl = root.querySelectorAll('[data-today-date]');
    var label = new Date().toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
    dateEl.forEach(function (el) { el.textContent = label; });
    show(today);
  });

  /* Bible plans */
  function planDone(slug) { return store.get('tayro-plan-' + slug, []); }
  function paintProgress(slug, total) {
    var done = planDone(slug).length;
    var pct = total ? Math.round((done / total) * 100) : 0;
    document.querySelectorAll('[data-plan-progress="' + slug + '"]').forEach(function (el) { el.style.width = pct + '%'; });
    document.querySelectorAll('[data-plan-count="' + slug + '"]').forEach(function (el) { el.textContent = done + ' of ' + total + ' days'; });
  }
  document.querySelectorAll('[data-plans]').forEach(function (root) {
    var list = root.querySelector('[data-plan-list]');
    var details = root.querySelectorAll('[data-plan-detail]');

    function open(slug, push) {
      var target = root.querySelector('[data-plan-detail="' + slug + '"]');
      if (!target) { close(false); return; }
      list.hidden = true;
      details.forEach(function (d) { d.hidden = d !== target; });
      if (push) history.pushState({ plan: slug }, '', '#' + slug);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function close(push) {
      list.hidden = false;
      details.forEach(function (d) { d.hidden = true; });
      if (push) history.pushState({}, '', location.pathname + location.search);
    }

    root.querySelectorAll('[data-open-plan]').forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn.getAttribute('data-open-plan'), true); });
    });
    root.querySelectorAll('[data-close-plan]').forEach(function (btn) {
      btn.addEventListener('click', function () { close(true); });
    });

    details.forEach(function (detail) {
      var slug = detail.getAttribute('data-plan-detail');
      var dayEls = detail.querySelectorAll('[data-day]');
      var total = dayEls.length;
      function paintDays() {
        var done = planDone(slug);
        dayEls.forEach(function (dayEl) {
          var i = Number(dayEl.getAttribute('data-day'));
          var isDone = done.indexOf(i) !== -1;
          var btn = dayEl.querySelector('[data-mark]');
          dayEl.classList.toggle('is-done', isDone);
          btn.classList.toggle('is-done', isDone);
          btn.textContent = isDone ? '✓ Done' : 'Mark read';
          btn.setAttribute('aria-pressed', isDone ? 'true' : 'false');
        });
        paintProgress(slug, total);
      }
      detail.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mark]');
        if (!btn) return;
        var i = Number(btn.closest('[data-day]').getAttribute('data-day'));
        var done = planDone(slug);
        var at = done.indexOf(i);
        if (at === -1) done.push(i); else done.splice(at, 1);
        store.set('tayro-plan-' + slug, done);
        var index = store.get('tayro-plans-index', {});
        index[slug] = { title: detail.getAttribute('data-plan-title'), total: total, url: location.pathname + '#' + slug };
        store.set('tayro-plans-index', index);
        paintDays();
      });
      paintDays();
    });

    function fromHash() {
      var slug = location.hash.replace('#', '');
      if (slug) open(slug, false); else close(false);
    }
    window.addEventListener('popstate', fromHash);
    fromHash();
  });

  /* Account page: reading progress */
  document.querySelectorAll('[data-reading-list]').forEach(function (ul) {
    var index = store.get('tayro-plans-index', {});
    var slugs = Object.keys(index);
    if (!slugs.length) return;
    ul.innerHTML = '';
    slugs.forEach(function (slug) {
      var info = index[slug];
      var done = planDone(slug).length;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = info.url; a.textContent = info.title;
      var span = document.createElement('span');
      span.textContent = done + '/' + info.total;
      li.appendChild(a); li.appendChild(span);
      ul.appendChild(li);
    });
  });

  /* Product form: options -> variant */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var submit = form.querySelector('[type="submit"]');
    var priceEl = document.querySelector('[data-product-price]');
    function update() {
      var chosen = {};
      form.querySelectorAll('[data-option-position]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) chosen[fs.getAttribute('data-option-position')] = checked.value;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (val, i) { return chosen[i + 1] === undefined || chosen[i + 1] === val; });
      });
      if (!match) { submit.disabled = true; submit.textContent = 'Unavailable'; return; }
      idInput.value = match.id;
      submit.disabled = !match.available;
      submit.textContent = match.available ? 'Add to cart' : 'Sold out';
      if (priceEl) priceEl.textContent = match.price_formatted;
      var url = new URL(location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url);
    }
    form.addEventListener('change', update);
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var next = Math.max(Number(input.min || 0), Number(input.value || 0) + Number(btn.getAttribute('data-qty')));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
